import {
	PagedMultiSelectField,
	PagedSingleSelectField,
	SelectDefaultOption,
	SelectSingleChangeHandler,
	laravelSelectFetchConfig,
	laravelServiceSelectFetchConfig,
	useFormatDateTime,
} from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { eventService } from "../api/event/eventService";
import { ApprovableEventOptionResource } from "../types";

const Small = styled.small<{ $isSelected: boolean }>`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
	color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.dropdown.active : theme.colors.palette.grey[70])};
`;

interface Props {
	name: string;
	label: string;
	onChange?: SelectSingleChangeHandler<ApprovableEventOptionResource>;
	clearable?: boolean;
	required?: boolean;
	disabled?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(eventService);

export const EventSingleSelect: FC<Props> = ({ name, label, clearable, required, disabled }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			clearable={clearable}
			required={required}
			disabled={disabled}
			fetchConfig={fetchConfig}
		/>
	);
};

export const EventMultiSelect: FC<Props> = ({ name, label, clearable, required, disabled }) => {
	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			clearable={clearable}
			required={required}
			disabled={disabled}
			fetchConfig={fetchConfig}
		/>
	);
};

export const ApprovableEventSingleSelect: FC<Props> = (props) => {
	const formatDateTime = useFormatDateTime();

	return (
		<PagedSingleSelectField
			{...props}
			fetchConfig={laravelSelectFetchConfig(eventService.approvableOptionsKey, (search, page) =>
				eventService.approvableOptions(search, page).then((r) => r.data),
			)}
			renderOption={(o, isSelected, isHovered) => (
				<SelectDefaultOption $isSelected={isSelected} $isHovered={isHovered}>
					<div>{o.name}</div>
					<Small $isSelected={isSelected}>
						{" "}
						{formatDateTime(o.start)}
						{" - "}
						{formatDateTime(o.end)}
					</Small>
				</SelectDefaultOption>
			)}
		/>
	);
};
